export default {
    page_title: "Kevi | Relatório de E-mail Marketing",
    title: "Relatório de E-mail Marketing",
    stats: {
        total_sent: "E-mails Enviados",
        delivered: "Entregues",
        opened: "Abertos",
        clicked: "Cliques",
        failed: "Falhas",
        total_orders: "Pedidos Convertidos",
        total_reactivated_orders: "Pedidos Reativados",
        total_revenue: "Faturamento Incentivado",
    },
    chart: {
        sent: "Enviados",
        delivered: "Entregues",
        opened: "Abertos",
        clicked: "Cliques",
    },
    table: {
        title: "Desempenho por Automação",
        automation: "Automação",
        sent: "Enviados",
        delivered: "Entregues",
        opened: "Abertos",
        clicked: "Cliques",
        replies: "Respostas",
        open_rate: "Taxa de Abertura",
        click_rate: "Taxa de Clique",
        orders_count: "Pedidos Convertidos",
        reactivated_orders_count: "Pedidos Reativados",
        revenue: "Faturamento Incentivado",
        export_csv: "Exportar CSV",
        exporting: "Exportando...",
        export_filename: "relatorio-email-automacoes",
    },
    filters: {
        status_label: "Situação",
        automation_label: "Automação",
        status_accepted: "Aceita",
        status_scheduled: "Agendada",
        status_sent: "Enviada",
        status_failed: "Falha",
    },
    empty: {
        no_emails_message: "Você não enviou nenhum email no período",
        create_automation: "Criar Automação",
        no_tracking_message: "Converse com o nosso suporte para ativar o rastreamento de cliques e aberturas no seu disparador de email",
        no_data_period: "Não há dados suficientes para o período selecionado",
    },
};
